<script>
/* globals window */
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            activeListItem: '',
            activeItem: 'list',
            listHeightStyle: { }
        }
    },
    mounted() {
        this.getHeight();
        this.$eventsBus.$on('marker-over', this.handleMarkerOver);
        this.$eventsBus.$on('marker-out', this.handleMarkerOut);
    },
    beforeDestroy() {
        this.$eventsBus.$off('marker-over', this.handleMarkerOver);
        this.$eventsBus.$off('marker-out', this.handleMarkerOut);
    },
    methods: {
        isActive: function (menuItem) {
            return this.activeItem === menuItem
        },
        setActive: function (menuItem) {
            this.activeItem = menuItem;
            // need to run this when button gets clicked
            //google.maps.event.trigger(this.map, 'resize');
        },
        getHeight(event) {
            //var element = document.querySelectorAll('.list-view__contianer');
            var listHeight = this.$refs.tabs.clientHeight + 'px';
            if(window.matchMedia('(max-width: 991px)').matches) {
                Vue.set(this.listHeightStyle, 'height', listHeight);
            } else {
                return false;
            }
        //return listHeight;
        },
        handleMarkerOver(id) {
            this.activeListItem = id;
        },
        handleMarkerOut(id) {
            this.activeListItem = '';
        },
        handleCardOver(id) {
            this.$eventsBus.$emit('community-over', id);
        },
        handleCardOut(id) {
            this.$eventsBus.$emit('community-out', id);
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/components/apps/regional-landing-page-tab-toggle.vue